<template>
  <div class="wrapper">
    <h4>{{ titleName }}</h4>
    <el-form :model="form" ref="form" :rules="rules" label-width="150px">
      <el-row :gutter="24">
        <el-col :span="8">
          <el-form-item label="服务项目" prop="proejctName">
            <el-input v-model="form.proejctName" placeholder="请输入服务项目" auto-complete="off"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="养老顾问" prop="consultantId">
            <el-input v-model="form.consultantId" placeholder="请选择养老顾问" auto-complete="off" :disabled="true">
              <el-button slot="append" icon="el-icon-search" @click="selectConsultantId()"></el-button>
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="工作站点" prop="workStationId">
            <el-input v-model="form.workStationId" placeholder="请选择工作站点" auto-complete="off" :disabled="true">
              <el-button slot="append" icon="el-icon-search" @click="selectWorkStationId()"></el-button>
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="24">
        <el-col :span="8">
          <el-form-item label="服务开始时间" prop="serviceBeginTime">
            <el-date-picker
              v-model="form.serviceBeginTime"
              type="datetime"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss"
              placeholder="请选择服务开始时间"
            ></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="服务结束时间" prop="serviceEndTime">
            <el-date-picker
              v-model="form.serviceEndTime"
              type="datetime"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss"
              placeholder="请选择服务结束时间"
            ></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="满意度" prop="satisfaction">
            <el-input v-model="form.satisfaction" placeholder="请输入满意度" auto-complete="off"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="24">
        <el-col :span="8">
          <el-form-item label="服务状态" prop="tel">
            <el-input v-model="form.serviceStatus" placeholder="请输入服务状态" auto-complete="off"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item style="text-align: center" label-width="0">
            <el-button type="primary" icon="fa fa-check" @click="submitEvent('form')">保存</el-button>
            <el-button icon="fa fa-undo" @click="$router.go(-1)">返回</el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <el-dialog title="选择养老顾问" :visible.sync="visible" width="50%" :close-on-click-modal="false">
      <div>
        <div>
          养老顾问姓名：
          <el-input style="width:200px;margin-right:10px;" size="medium" v-model="searchData.consName" placeholder="请输入养老顾问姓名"></el-input>
          <el-button size="medium" type="primary" @click="search">搜索</el-button>
        </div>
        <div style="margin-top:10px;">
          <el-table :data="tableData" ref="singleTable" highlight-current-row border size="medium" :height="height">
            <el-table-column label="" width="40">
              <template slot-scope="scope">
                <el-radio
                  :label="scope.$index"
                  v-model="radio"
                  @change.native="getCurrentRow(scope.row)"
                  style="color: #fff;padding-left: 10px; margin-right: -25px;"
                ></el-radio>
              </template>
            </el-table-column>
            <el-table-column prop="name" width="120" label="姓名"></el-table-column>
            <el-table-column prop="sex" label="性别" width="60"></el-table-column>
            <el-table-column prop="idNum" label="身份证" width="180"></el-table-column>
            <el-table-column prop="serviceTimes" label="服务次数" width="100"></el-table-column>
            <el-table-column prop="address" label="地址" width="156"></el-table-column>
          </el-table>
          <div style="text-align: right; margin-top: 10px;">
            <el-pagination
              background
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="tablePage.currentPage"
              :page-sizes="[50, 100, 500]"
              :page-size="tablePage.pageSize"
              layout="total,jumper,prev, pager, next,sizes"
              :total="tablePage.totalResult"
            ></el-pagination>
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancel()">取 消</el-button>
        <el-button type="primary" @click="cancel()">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="选择工作站点" :visible.sync="visible1" width="50%" :close-on-click-modal="false">
      <div>
        <div>
          工作站点名称：
          <el-input style="width:200px;margin-right:10px;" size="medium" v-model="searchData1.siteName" placeholder="请输入服务人员姓名"></el-input>
          <el-button size="medium" type="primary" @click="search1">搜索</el-button>
        </div>
        <div style="margin-top:10px;">
          <el-table :data="tableData1" ref="singleTable" highlight-current-row border size="medium" :height="height">
            <el-table-column label="" width="40">
              <template slot-scope="scope">
                <el-radio
                  :label="scope.$index"
                  v-model="radio1"
                  @change.native="getCurrentRow1(scope.row)"
                  style="color: #fff;padding-left: 10px; margin-right: -25px;"
                ></el-radio>
              </template>
            </el-table-column>
            <el-table-column prop="siteName" width="120" label="名称"></el-table-column>
            <el-table-column prop="natureName" label="性质" width="60"></el-table-column>
            <el-table-column prop="siteStatusName" label="状态" width="140"></el-table-column>
            <el-table-column prop="mainPersonTel" label="联系方式" width="120"></el-table-column>
            <el-table-column prop="detailAddress" label="详细地址" width="156"></el-table-column>
          </el-table>
          <div style="text-align: right; margin-top: 10px;">
            <el-pagination
              background
              @size-change="handleSizeChange1"
              @current-change="handleCurrentChange1"
              :current-page="tablePage1.currentPage"
              :page-sizes="[50, 100, 500]"
              :page-size="tablePage1.pageSize"
              layout="total,jumper,prev, pager, next,sizes"
              :total="tablePage1.totalResult"
            ></el-pagination>
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancel1()">取 消</el-button>
        <el-button type="primary" @click="cancel1()">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'AddOrEdit',
  data() {
    return {
      radio: '',
      height: 240,
      tableData: [],
      tablePage: {
        totalResult: 0,
        currentPage: 1,
        pageSize: 10,
        align: 'left',
        pageSizes: [10, 20, 50, 100, 500, 1000],
        perfect: true,
      },
      visible: false,
      searchData: {
        personName: '',
      },
      radio1: '',
      tableData1: [],
      tablePage1: {
        totalResult: 0,
        currentPage: 1,
        pageSize: 10,
        align: 'left',
        pageSizes: [10, 20, 50, 100, 500, 1000],
        perfect: true,
      },
      visible1: false,
      searchData1: {
        siteName: '',
      },
      homeServRecdStatusLst: [],
      titleName: '',
      form: {},
      rules: {
        proejctName: [{ required: true, message: '请输入服务项目', trigger: 'blur' }],
        consultantId: [{ required: true, message: '请选择养老顾问', trigger: 'blur' }],
        workStationId: [{ required: true, message: '请选择工作站点', trigger: 'blur' }],
        serviceBeginTime: [{ required: true, message: '请选择服务开始时间', trigger: 'blur' }],
        serviceEndTime: [{ required: true, message: '请选择服务结束时间', trigger: 'blur' }],
        satisfaction: [
          { required: true, message: '请输入满意度', trigger: 'blur' },
          { pattern: /^([0-9]{1,2}|100)$/, message: '请检查满意度格式' },
        ],
        serviceStatus: [{ required: true, message: '请输入服务状态', trigger: 'blur' }],
      },
    }
  },
  computed: {
    routeType() {
      return this.$route.params.type
    },
  },
  created() {
    this.initView()
    // this.getDicList()
  },
  methods: {
    ...mapActions(['addOrSaveConsServiceRecord', 'detailConsServiceRecord', 'getSysDictServe', 'consConsultantPage', 'getServceStationList']),
    getCurrentRow(row) {
      this.form.consultantId = row.id
    },
    getCurrentRow1(row) {
      this.form.workStationId = row.id
      this.form.workStationName = row.siteName
    },
    cancel() {
      this.visible = false
    },
    cancel1() {
      this.visible1 = false
    },
    search() {
      this.getConsConsultant()
    },
    search1() {
      this.getworkStationIdInfo()
    },

    handleSizeChange: function(size) {
      this.tablePage.pageSize = size
      this.getConsConsultant()
    },
    handleSizeChange1: function(size) {
      this.tablePage1.pageSize = size
      this.getworkStationIdInfo()
    },
    // 控制页面的切换
    handleCurrentChange: function(currentPage) {
      this.tablePage.currentPage = currentPage
      this.getConsConsultant()
    },
    // 控制页面的切换
    handleCurrentChange1: function(currentPage) {
      this.tablePage1.currentPage = currentPage
      this.getworkStationIdInfo()
    },
    getConsConsultant() {
      let params = {
        current: this.tablePage.currentPage,
        size: this.tablePage.pageSize,
        param: {
          consName: this.searchData.consName,
        },
      }
      let data = null
      let server = 'consConsultantPage'
      this[server](params).then((res) => {
        if (res.code == 200) {
          this.tableData = res.data.records
          this.tablePage.totalResult = +res.data.total
        }
      })
    },
    getworkStationIdInfo() {
      let params = {
        current: this.tablePage1.currentPage,
        size: this.tablePage1.pageSize,
        param: {
          siteName: this.searchData1.siteName,
        },
      }
      let data = null
      let server = 'getServceStationList'
      this[server](params).then((res) => {
        if (res.code == 200) {
          this.tableData1 = res.data.records
          this.tablePage1.totalResult = +res.data.total
        }
      })
    },
    initView() {
      if (this.routeType == 'add') {
        this.titleName = '添加服务记录'
      } else {
        this.titleName = '修改服务记录'
        this.itemData = JSON.parse(this.$route.query.item)
        //这里调用请求编辑时的详情接口渲染form表单数据
        let params = {
          id: this.itemData.id,
        }
        let data = null
        let server = 'detailConsServiceRecord'
        this[server](params).then((res) => {
          if (res.code == 200) {
            data = res.data
            this.form = {
              id: data.id,
              proejctName: data.proejctName,
              consultantId: data.consultantId,
              workStationId: data.workStationId,
              workStationName: data.workStationName,
              serviceBeginTime: data.serviceBeginTime,
              serviceEndTime: data.serviceEndTime,
              satisfaction: data.satisfaction,
              serviceStatus: data.serviceStatus,
            }
          }
        })
      }
      this.getConsConsultant()
      this.getworkStationIdInfo()
    },
    submitEvent(formName) {
      if (!this.form.consultantId) {
        this.$XModal.message({
          message: '请检查养老顾问是否已选择',
          status: 'warning',
        })
        return
      }
      if (!this.form.workStationId) {
        this.$XModal.message({
          message: '请检查工作站点是否已选择',
          status: 'warning',
        })
        return
      }
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let startTime = Date.parse(this.form.serviceBeginTime)
          let endTime = Date.parse(this.form.serviceEndTime)
          if (startTime > endTime) {
            this.$XModal.message({
              message: '服务结束时间应该大于服务开始时间',
              status: 'warning',
            })
            return
          }
          let params = {
            ...this.form,
            proejctId: null,
          }
          let server = 'addOrSaveConsServiceRecord'
          this[server](params).then((res) => {
            if (res.code == 200) {
              this.$XModal.message({
                message: this.routeType == 'add' ? '添加成功' : '修改成功',
                status: 'success',
              })
              this.$router.go(-1)
            }
            this.loading = false
          })
        } else {
          return false
        }
      })
    },
    selectConsultantId() {
      this.visible = true
    },
    selectWorkStationId() {
      this.visible1 = true
    },
  },
}
</script>

<style lang="scss" scoped>
.wrapper {
  padding: 10px;
  overflow: hidden;
  h4 {
    height: 40px;
    line-height: 40px;
    color: #333;
    padding-left: 20px;
    margin-bottom: 20px;
  }
}
</style>
